import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { accountService, alertService } from '../_services';
import { withRouter } from "react-router";
import { useTranslation } from "react-i18next";

function ActivateReservation({ location, history }) {
    const { t } = useTranslation();
    let { reservationId } = useParams();
    const initialValues = {
        accessCode: '',
        confAccessCode: ''
    };
    const user = accountService.userValue;

    //.test('len', 'Must be exactly 4 numbers', val => val.toString().length === 4)
    const validationSchema = Yup.object().shape({
      accessCode:
        Yup.string()
          .required(t("This field is required"))
          .matches(/^[0-9]+$/, t('activate.digits'))
          .min(4, t('activate.minMax'))
          .max(4, t('activate.minMax'))
        ,
        confAccessCode: Yup.string()
            .required(t("This field is required"))
            .test('codes-match', t('Access codes must match.'), function (value) {
                return this.parent.accessCode === value;
            })
    });

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        let res_id = reservationId;
        accountService.activateReservation(parseInt(res_id), fields.accessCode.toString())
            .then((data) => {
                setSubmitting(false);
                //alertService.success("Activation Successful!", { keepAfterRouteChange: true });
                alertService.success("Check-In Successful!");
                history.push('/reservations/active')
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });

    }

    return (

        <div className="card m-3">
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                {({ errors, touched, isSubmitting }) => (
                    <Form>
                        <div className="card-header">
                            <h1 className="bold-tx">{t("Check - In")}</h1>
                            <h4>{t('activate.intro')}</h4>
                            <h6>{t('activate.description')}</h6>
                        </div>

                        <div className="card-body">

                            <div className="form-row">
                                <div className="form-group col-4 col-4-rs">
                                    <label className="ck-in-l">{t('Locker Access Code')}</label>
                    <Field name="accessCode" type="tel" pattern="[0-9]*" maxLength={4} className={'activate form-control ck-in-r' + (errors.accessCode && touched.accessCode ? ' is-invalid' : '')} />
                                    <ErrorMessage name="accessCode" component="div" className="invalid-feedback" />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group col-4 col-4-rs">
                                    <label className="ck-in-l">{t('Confirm Access Code')}</label>
                    <Field name="confAccessCode" type="tel" pattern="[0-9]*" maxLength={4} className={'activate form-control ck-in-r' + (errors.confAccessCode && touched.confAccessCode ? ' is-invalid' : '')} />
                                    <ErrorMessage name="confAccessCode" component="div" className="invalid-feedback" />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">

                                    <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                        {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                        {t("Check-In")}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h3 className="card-header cust-footer">
                                <Link to="/reservations/all" className="btn btn-link">{t('Cancel')}</Link>
                            </h3>
                        </div>
                    </Form>
                )}
            </Formik>

        </div>

    )
}


export { ActivateReservation }; 